// this is the new shit

const SCROLL_BUFFER = 5;
const MOBILE_WIDTH_BREAKPOINT = 720;

// Utility function
function isMobileView() {
  return window.innerWidth <= MOBILE_WIDTH_BREAKPOINT;
}

// Sync thumbnail height on desktop
function syncThumbnailHeight() {
  const hero = document.querySelector('.product-big-image');
  const thumbs = document.getElementById('thumbnail-container');
  const scroll = document.querySelector('.thumbnails-scrollbox');

  if (!hero || !thumbs || !scroll) return;

  if (!isMobileView()) {
    const heroHeight = hero.clientHeight;
    let thumbsHeight, scrollHeight;

    if (heroHeight < 300) {
      thumbsHeight = heroHeight + 150;
      scrollHeight = heroHeight + 100;
    } else if (heroHeight < 400) {
      thumbsHeight = heroHeight + 50;
      scrollHeight = heroHeight;
    } else {
      thumbsHeight = heroHeight - 5;
      scrollHeight = heroHeight - 65;
    }

    thumbs.style.height = `${thumbsHeight}px`;
    scroll.style.height = `${scrollHeight}px`;
  } else {
    thumbs.style.height = 'auto';
    scroll.style.height = 'auto';
  }
}

// Handle scroll arrow button click
function scrollThumbnails(direction) {
  const scrollBox = document.querySelector('.thumbnails-scrollbox');
  const isMobile = isMobileView();

  if (!scrollBox) return;

  smoothScroll(scrollBox, direction, isMobile, 100, 300, 30);
  
  // fixing Firefox Scroll issues
/*  const scrollBox = document.querySelector('.thumbnails-scrollbox');
  const scrollAmount = 100;

  if (!scrollBox) return;

  scrollBox.scrollBy({
    [isMobileView() ? 'left' : 'top']: direction * scrollAmount,
    behavior: 'smooth'
  });
  */
}

// Update arrow visibility, enable/disable state, and fade mask
function updateThumbnailScrollControls() {
  const wrapper = document.querySelector('.thumbnails-scroll-wrapper');
  const scrollBox = document.querySelector('.thumbnails-scrollbox');
  const upArrow = document.querySelector('.scroll-arrow.scroll-up');
  const downArrow = document.querySelector('.scroll-arrow.scroll-down');

  if (!scrollBox || !upArrow || !downArrow) return;

  const mobile = isMobileView();

  // Set direction-aware ARIA labels
  upArrow.setAttribute('aria-label', mobile ? 'Scroll Left' : 'Scroll Up');
  downArrow.setAttribute('aria-label', mobile ? 'Scroll Right' : 'Scroll Down');

  // === Step 1: Measure real scroll overflow ===
  const scrollSize = mobile ? scrollBox.scrollWidth : scrollBox.scrollHeight;
  const clientSize = mobile ? scrollBox.clientWidth : scrollBox.clientHeight;
  const scrollPos = mobile ? scrollBox.scrollLeft : scrollBox.scrollTop;
  const scrollEnd = scrollPos + clientSize;

  const scrollDiff = Math.ceil(scrollSize - clientSize);
  const needsScroll = scrollDiff > SCROLL_BUFFER && scrollSize > 0 && clientSize > 0;

  // === Step 2: Determine scrollable directions ===
  const canScrollBackward = scrollPos > SCROLL_BUFFER;
  const canScrollForward = Math.ceil(scrollEnd) < scrollSize - SCROLL_BUFFER;

  // === Step 3: Show/hide arrows visually ===
  if (needsScroll) {
    upArrow.classList.add('visible');
    downArrow.classList.add('visible');
    wrapper.classList.add('has-scroll-arrows');
  } else {
    upArrow.classList.remove('visible');
    downArrow.classList.remove('visible');
    wrapper.classList.remove('has-scroll-arrows');
  }

  //upArrow.classList.remove('hidden-arrow');
  //downArrow.classList.remove('hidden-arrow');

  // === Step 4: Enable/disable arrows ===
  if (needsScroll) {
    upArrow.disabled = !canScrollBackward;
    downArrow.disabled = !canScrollForward;
  } else {
    upArrow.disabled = true;
    downArrow.disabled = true;
  }

  // === Step 5: Optional fade mask & layout fallback ===
  scrollBox.classList.toggle('fade-mask', needsScroll);
  //scrollBox.classList.toggle('non-scrollable', mobile && !needsScroll);

  // === Step 6: Hide scroll spacer if not needed ===
  const spacers = document.querySelectorAll('.scroll-spacer');
  if (spacers) {
    for (var i = 0; i < spacers.length; i++) {
      spacers[i].style.display = needsScroll ? 'block' : 'none';
    }
  }
}

// Bind all event listeners
function initializeThumbnailUI() {
  const scrollBox = document.querySelector('.thumbnails-scrollbox');

  if (!scrollBox) return;

  // Sync heights on image load
  const heroImg = document.getElementById('primary-image-hero');
  if (heroImg) {
    if (heroImg.complete) {
      syncThumbnailHeight();
      updateThumbnailScrollControls();
    } else {
      heroImg.onload = () => {
        syncThumbnailHeight();
        updateThumbnailScrollControls();
      };
    }
  }

  // Resize events (debounced)
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      syncThumbnailHeight();
      updateThumbnailScrollControls();
    }, 100);
  });

  // Scroll events
  scrollBox.addEventListener('scroll', updateThumbnailScrollControls);

  // Initial state on load
  window.addEventListener('load', () => {
    syncThumbnailHeight();
    updateThumbnailScrollControls();
  });

  // Arrow click handlers
  const upArrow = document.querySelector('.scroll-arrow.scroll-up');
  const downArrow = document.querySelector('.scroll-arrow.scroll-down');

  if (upArrow && downArrow) {
    upArrow.addEventListener('click', () => scrollThumbnails(-1));
    downArrow.addEventListener('click', () => scrollThumbnails(1));
  }
}

// Kick it off
initializeThumbnailUI();

// To fix Firefox scroll issues:
function smoothScroll(scrollBox, direction, isHorizontal, distance = 100, duration = 300, snapThreshold = 30) {
  const current = isHorizontal ? scrollBox.scrollLeft : scrollBox.scrollTop;
  const maxScroll = isHorizontal
    ? scrollBox.scrollWidth - scrollBox.clientWidth
    : scrollBox.scrollHeight - scrollBox.clientHeight;

  let target = current + direction * distance;

  // Snap to end if within threshold
  if (direction > 0 && maxScroll - target < snapThreshold) {
    target = maxScroll;
  } else if (direction < 0 && target < snapThreshold) {
    target = 0;
  }

  const startTime = performance.now();

  function animateScroll(time) {
    const elapsed = time - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const ease = progress < 0.5
      ? 2 * progress * progress
      : -1 + (4 - 2 * progress) * progress;

    const newPos = current + (target - current) * ease;

    if (isHorizontal) {
      scrollBox.scrollLeft = newPos;
    } else {
      scrollBox.scrollTop = newPos;
    }

    if (progress < 1) {
      requestAnimationFrame(animateScroll);
    }
  }

  requestAnimationFrame(animateScroll);
}




/*
// this is the old shit
function syncThumbnailHeight() {
  const hero = document.querySelector('.product-big-image');
  const thumbs = document.getElementById('thumbnail-container');
  const scroll = document.querySelector('.thumbnails-scrollbox');
                                         
  if (!hero || !thumbs || !scroll) return;
  
  // Only apply on desktop
  if (window.innerWidth > 720 && hero && thumbs && scroll) {
    if (hero.clientHeight < 300) {
      thumbs.style.height = `${hero.clientHeight + 150}px`;
      scroll.style.height = `${hero.clientHeight + 100}px`;
      return;
    }
    if (hero.clientHeight < 400) {
      thumbs.style.height = `${hero.clientHeight + 50}px`;
      scroll.style.height = `${hero.clientHeight}px`;
      return;
    }
    thumbs.style.height = `${hero.clientHeight - 5}px`;
    scroll.style.height = `${hero.clientHeight - 65}px`;
  } else if (thumbs && scroll) {
    thumbs.style.height = 'auto';
    scroll.style.height = 'auto';
  }
}

// Image load event — this is better than waiting for full window load
const heroImg = document.getElementById('primary-image-hero');
if (heroImg.complete) {
  // If image was cached and already loaded
  syncThumbnailHeight();
} else {
  heroImg.onload = syncThumbnailHeight;
}

// Resize for responsive layouts
window.addEventListener('resize', syncThumbnailHeight);



function scrollThumbnails(direction) {
  const scrollBox = document.querySelector('.thumbnails-scrollbox');
  const isMobile = window.innerWidth <= 720;
  const scrollAmount = 100; // Pixels to scroll

  if (isMobile) {
    scrollBox.scrollBy({
      left: direction * scrollAmount,
      behavior: 'smooth'
    });
  } else {
    scrollBox.scrollBy({
      top: direction * scrollAmount,
      behavior: 'smooth'
    });
  }
}

// Add event listeners
document.querySelector('.scroll-up').addEventListener('click', () => scrollThumbnails(-1));
document.querySelector('.scroll-down').addEventListener('click', () => scrollThumbnails(1));


function updateScrollArrows() {
  const isMobile = window.innerWidth <= 720;
  
  const upArrow = document.querySelector('.scroll-arrow.scroll-up');
  const downArrow = document.querySelector('.scroll-arrow.scroll-down');

  if (!upArrow || !downArrow) return;

  if (isMobile) {
    // Mobile = Left/Right
    //upArrow.innerHTML = '◀'; 
    upArrow.setAttribute('aria-label', 'Scroll Left');

    //downArrow.innerHTML = '▶'; 
    downArrow.setAttribute('aria-label', 'Scroll Right');
  } else {
    // Desktop = Up/Down
    //upArrow.innerHTML = '▲'; 
    upArrow.setAttribute('aria-label', 'Scroll Up');

    //downArrow.innerHTML = '▼'; 
    downArrow.setAttribute('aria-label', 'Scroll Down');
  }
}

// Run on load and resize
window.addEventListener('load', updateScrollArrows);
window.addEventListener('resize', updateScrollArrows);

// Fade mask logic
function updateFadeMask() {
  const box = document.querySelector('.thumbnails-scrollbox');
  if (!box) return;

  const needsScroll = box.scrollHeight > box.clientHeight;
  box.classList.toggle('fade-mask', needsScroll);
}

function updateThumbnailScrollControls() {
  const scrollBox = document.querySelector('.thumbnails-scrollbox');
  const upArrow = document.querySelector('.scroll-arrow.scroll-up');
  const downArrow = document.querySelector('.scroll-arrow.scroll-down');

  if (!scrollBox || !upArrow || !downArrow) return;

  const isMobile = window.innerWidth <= 720;

  let needsScroll, canScrollBackward, canScrollForward;

  const SCROLL_BUFFER = 2;

  if (isMobile) {
    const scrollable = scrollBox.scrollWidth > scrollBox.clientWidth + 1;
    scrollBox.classList.toggle('non-scrollable', !scrollable);
      
    needsScroll = Math.round(scrollBox.scrollWidth) - Math.round(scrollBox.clientWidth) > SCROLL_BUFFER;
    canScrollBackward = scrollBox.scrollLeft > SCROLL_BUFFER;
    canScrollForward = scrollBox.scrollLeft + scrollBox.clientWidth < scrollBox.scrollWidth - SCROLL_BUFFER;
  } else {
    needsScroll = scrollBox.scrollHeight - scrollBox.clientHeight > SCROLL_BUFFER;
    canScrollBackward = scrollBox.scrollTop > SCROLL_BUFFER;
    canScrollForward = Math.ceil(scrollBox.scrollTop + scrollBox.clientHeight) < scrollBox.scrollHeight - SCROLL_BUFFER;
  }


  // Show/hide arrows
  //upArrow.classList.toggle('visible', needsScroll);
  //downArrow.classList.toggle('visible', needsScroll);


  // Enable/disable arrows
  if (needsScroll) {
    upArrow.disabled = !canScrollBackward;
    downArrow.disabled = !canScrollForward;
  }
}

// Call on load, resize, and scroll
window.addEventListener('load', updateThumbnailScrollControls);

let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(updateThumbnailScrollControls, 100); // Adjust as needed
});

document.querySelector('.thumbnails-scrollbox').addEventListener('scroll', updateThumbnailScrollControls);
*/